class BrandDetail extends HTMLElement {
    constructor() {
        super();
        this.vendorHandle = this.getAttribute("data-vendor-handle");
        this.hasFilters = this.getAttribute("data-has-filters") == "true";
        this.getBrandDetailData();
        this.collapseDescription();
    }

    async getBrandDetailData() {
        try {
            const jsonCacheBust = Math.floor(Date.now() / 900000); // 900000 ms = 15 minutes
            const fetchRes = await fetch(`${ncol_api_url}/public/api/vendors/${this.vendorHandle}.json?v=${jsonCacheBust}`);
            const data = await fetchRes.json();
            this.ctas = data.ctas;
            this.squares = data.squares;
            this.setupBrandDetailHTML();
            this.setupBrandBanner(data.banner_image_url);
        } catch (e) {
            console.log(e);
        }
    }

    setupBrandDetailHTML() {
        if (!this.hasFilters) {
            const squareHTML = this.squares
                .map((square, index) => {
                    const imgTag = square.img ? `<img alt="" src="${square.img}" class="brand-detail-square__img" />` : `<div class="brand-detail-square__img brand-detail-square__img--no-media"></div>`;
                    const hiddenClass = index >= 4 ? "brand-detail-square--extra" : "";
                    return `
                    <div class="brand-detail-square ${hiddenClass}">
                        <a href="${square.url}" class="brand-detail-square__link">
                            ${imgTag}
                            <span class="brand-detail-square__label">${square.label}</span>
                        </a>
                    </div>
                `;
                })
                .join("");

            const showMoreButton = this.squares.length > 4 ? `<button class="brand-detail__show-more"><svg version="1.1" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!--Generated by IJSVG (https://github.com/iconjar/IJSVG)--><path d="M32,56l-1.04907e-06,-2.84217e-14c-13.2548,-5.79387e-07 -24,-10.7452 -24,-24c5.79387e-07,-13.2548 10.7452,-24 24,-24c13.2548,5.79387e-07 24,10.7452 24,24l2.13163e-14,-1.04907e-06c0,13.2548 -10.7452,24 -24,24Zm2,-11v0c0,1.10457 -0.895431,2 -2,2c-1.10457,0 -2,-0.895431 -2,-2v-11h-11h-8.74228e-08c-1.10457,-4.82823e-08 -2,-0.895431 -2,-2c4.82823e-08,-1.10457 0.895431,-2 2,-2h11v-11l2.13163e-14,3.01992e-07c-1.66785e-07,-1.10457 0.89543,-2 2,-2c1.10457,-1.66785e-07 2,0.89543 2,2c0,0 0,0 0,0v11h11l-8.74228e-08,3.55271e-15c1.10457,-4.82823e-08 2,0.89543 2,2c4.82823e-08,1.10457 -0.89543,2 -2,2h-11Z" fill="#000" fill-rule="evenodd"></path></svg><span>More Styles</span></button>` : "";
            const contractedClass = this.squares.length > 4 ? "brand-detail-content--contracted" : "";
            const brandDetailHTML = `<div class="brand-detail-content page-width ${contractedClass}">${squareHTML}${showMoreButton}</div>`;
            document.querySelector("#js-brand-detail-content").innerHTML = brandDetailHTML;

            if (this.squares.length > 4) {
                document.querySelector(".brand-detail__show-more").addEventListener("click", () => {
                    const hiddenSquares = document.querySelectorAll(".brand-detail-square--extra");
                    document.querySelector(".brand-detail-content").classList.remove("brand-detail-content--contracted");
                    if (hiddenSquares.length > 0) {
                        hiddenSquares[0].querySelector("a").focus();
                    }
                });
            }
        }

        const brandDetailCTAHTML = this.ctas.map((cta) => `<a href="${cta.url}" class="button">${cta.label}</a>`).join("");
        document.querySelector("#js-brand-detail-cta").innerHTML = brandDetailCTAHTML;
    }

    collapseDescription() {
        // add read more button for brand descriptions in collection banner
        const brandDescriptions = this.querySelectorAll(".js-brand-detail-description");
        brandDescriptions.forEach((description) => {
            description.dataset.open = "false";
            const descriptionContainer = description.querySelector(".js-brand-detail-description-inner");

            // If description text is only 1 sentence, don't need to add read more.
            if (descriptionContainer.innerHTML.split(". ").length < 2) return;

            let summaryContainer = null;

            const insertSummarySentence = (parent) => {
                const descriptionTextArray = parent.innerHTML.split(". ");

                let firstSentence = descriptionTextArray[0];
                if (firstSentence[firstSentence.length - 1] !== ".") firstSentence += ". ";
                else firstSentence += " ";

                const restOfText = descriptionTextArray.slice(1).join(". ");

                parent.innerHTML = "";

                const firstSentenceSpan = document.createElement("span");
                firstSentenceSpan.innerHTML = firstSentence;
                parent.appendChild(firstSentenceSpan);
                summaryContainer = firstSentenceSpan;

                if (!restOfText.length) return;

                const restOfTextSpan = document.createElement("span");
                restOfTextSpan.classList.add("brand-detail__description-rest");
                restOfTextSpan.innerHTML = restOfText;
                parent.appendChild(restOfTextSpan);
            };

            // If description text includes HTML, use the first sentence in the first paragraph as the summary.
            if (descriptionContainer.innerHTML.includes("<p>")) {
                const paragraphs = descriptionContainer.querySelectorAll("p");
                insertSummarySentence(paragraphs[0]);

                // If there's more than 1 paragraph, all other paragraphs are hidden.
                if (paragraphs.length > 1)
                    for (let i = 1; i < paragraphs.length; i++) {
                        paragraphs[i].classList.add("brand-detail__description-rest");
                    }
            } else insertSummarySentence(descriptionContainer);

            // add read more button
            const readMoreButton = document.createElement("button");
            readMoreButton.classList.add("brand-detail__read-more");
            readMoreButton.textContent = "Read More";
            summaryContainer.appendChild(readMoreButton);
            readMoreButton.addEventListener("click", () => {
                description.dataset.open = "true";
            });
        });
    }

    setupBrandBanner(bannerImageUrl) {
        if (!bannerImageUrl) return;
        const container = this.querySelector("[data-brand-banner]");

        const element = new Image();
        element.src = bannerImageUrl;
        element.alt = "";
        element.onload = () => {
            container.appendChild(element);
            container.removeAttribute("hidden");
        };
    }
}
customElements.define("brand-detail", BrandDetail);
